import { render, staticRenderFns } from "./wuju-breathe.vue?vue&type=template&id=1d142369&scoped=true&"
import script from "./wuju-breathe.vue?vue&type=script&lang=js&"
export * from "./wuju-breathe.vue?vue&type=script&lang=js&"
import style0 from "./wuju-breathe.vue?vue&type=style&index=0&id=1d142369&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d142369",
  null
  
)

export default component.exports